// @flow
export { default } from './PopperComponent';
